import * as React from 'react';

import * as styles from './InlineFilter.css';
import { UIText2 } from '@cian/ui-kit';

interface IInlineFilterProps {
  label?: string;
  postfix?: string;
  dataTestId?: string;
  width?: number;
}

export const InlineFilter: React.FC<React.PropsWithChildren<IInlineFilterProps>> = ({
  label,
  postfix,
  children,
  width,
  dataTestId,
}) => {
  return (
    <div className={styles['container']} data-testid={dataTestId}>
      {label && <UIText2>{label}</UIText2>}

      <div style={{ width }}>{children}</div>

      {postfix && <UIText2>{postfix}</UIText2>}
    </div>
  );
};
